<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 20em !important;">
                <img src="/static/images/exclamation-yellow.svg" style="height: 10rem !important" />
                <div class="mt-5" style="font-size: 16px">
                    <!-- <div class="mb-4" style="font-size: 20px; color: #f30d0d">Delete Campaign</div> -->
                    Campaign Data Will Be Lost! Do You Want To Continue ? 
                </div>
                <div class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn new-no-button mr-4 px-4" @click="hideSelf">No</button>
                    <button class="btn new-yes-button ml-4 px-4" @click="confirmDateChange">Yes</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name"],
    methods: {
        hideSelf() {
            this.$emit("hideEndDateAlertModal");
            this.$modal.hide(this.modal_name);
        },
        confirmDateChange() {
            this.$emit("confirmEndDateChange");
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Campaign/Email/EndDateAlertModal.vue